module.exports = __webpack_public_path__ + "static/img/awards.ba52a38c.svg";